module.exports = __webpack_public_path__ + "img/article-gb-dwrg-3.5037c8f0.jpg";